import React, { useEffect } from "react"
import { Col, Input, Label, Row } from "reactstrap"
import Flatpickr from "react-flatpickr"
import TextInput from "components/Common/TextInput"
import SelectBox from "components/Common/SelectBox"
import BranchesAPI from "helpers/branches_backend_helper"
import CompanyAPI from "helpers/company_backend_helper"
import DateInput from "components/Common/DateInput"
import { BranchOptions } from "components/CustomSelect"
import DimensionInput from "components/Common/DimensionInput"

export default function FormInformation({
  form,
  setForm,
  handleSelectDate,
  handleChangeSelect,
  handleCheckboxInput,
  handleChangeInput,
  customerOptions,
  customerId,
  handleChangeCurrency,
}) {
  const loadBranch = async inputValue => {
    let params = {
      keyword: inputValue,
    }
    let res = await BranchesAPI.getList(params)
    return res.data
      .map(val => {
        return { label: val.branchName, value: val.id, org: val }
      })
      .filter(i => i.label.toLowerCase().includes(inputValue.toLowerCase()))
  }

  const loadCustomer = async inputValue => {
    let params = {
      branchId: form.storeId.value,
      keyword: inputValue,
    }
    let res = await CompanyAPI.getList(params)

    return res.data.map(val => {
      return { label: `${val.customerName}`, value: val.id }
    })
  }

  useEffect(() => {
    if (form?.storeId?.value) {
      loadCustomer()
    }
  }, [form?.storeId])

  return (
    <>
      <Row className="d-flex align-items-center">
        <Col md={1}>
          <Label>日付</Label>
        </Col>
        <Col md={3}>
          <DateInput
            className="form-control"
            value={form.orderDate}
            onChange={date => handleSelectDate(date[0], "orderDate")}
          />
        </Col>
        <Col md={1}>
          <Label>店舗</Label>
        </Col>
        <Col md={3}>
          <SelectBox
            isAsync
            loadOptions={loadBranch}
            value={form.storeId}
            onChange={value => handleChangeSelect(value, "storeId")}
            formatOptionLabel={item => <BranchOptions item={item} />}
          />
        </Col>

        <Col md={1}>
          <Label>担当者</Label>
        </Col>
        <Col md={2}>
          <Input type="text" disabled value={form?.manager} />
        </Col>
      </Row>
      <Row className="d-flex align-items-center mt-2">
        <Col md={1}>
          <Label>名前</Label>
        </Col>
        <Col md={3}>
          <SelectBox
            isAsync
            loadOptions={loadCustomer}
            defaultOptions={customerOptions}
            onChange={e => handleChangeSelect(e, "customerId")}
            value={customerId}
            isDisabled={form.guest}
          />
        </Col>
        <Col md={1}>
          <Input
            type="checkbox"
            id="guest"
            defaultChecked={form.guest}
            onChange={e => handleCheckboxInput(e, "guest")}
            name="guest"
          />
          <Label htmlFor="guest" className="mb-0 ms-2">
            ゲスト
          </Label>
        </Col>
        <Col md={3}>
          <Input
            type="text"
            id="guestName"
            name="guestName"
            placeholder="ゲスト名を入力"
            value={form.guestName}
            disabled={!form.guest}
            onChange={handleChangeInput}
          />
        </Col>
      </Row>
      <Row className="d-flex align-items-center mt-2">
        <Col md={1}>
          <Label>納期</Label>
        </Col>
        <Col md={3}>
          <Flatpickr
            className="form-control d-block"
            placeholder={""}
            value={form.deadline}
            options={{
              dateFormat: "Y-m-d",
            }}
            onChange={date => handleSelectDate(date[0], "deadline")}
          />
        </Col>
        <Col md={1}>
          <Label>備考</Label>
        </Col>
        <Col md={3}>
          <TextInput
            value={form.remarks}
            onChange={handleChangeInput}
            name="remarks"
          />
        </Col>
      </Row>
      <Row className="d-flex align-items-center mt-2">
        <Col md={1}>
          <Label>お渡し</Label>
        </Col>
        <Col md={5}>
          <Input
            name="delivery"
            className="mx-4"
            type="radio"
            value={"ご来店"}
            checked={form.delivery === "ご来店"}
            onClick={e => {
              setForm({ ...form, delivery: "ご来店" })
            }}
          />
          <Label>ご来店</Label>
          <Input
            name="delivery"
            className="mx-4"
            type="radio"
            value={"(ご配送）店舗"}
            checked={form.delivery === "(ご配送）店舗"}
            onClick={e => setForm({ ...form, delivery: "(ご配送）店舗" })}
          />
          <Label>（ご配送）店舗</Label>
          <Input
            name="delivery"
            className="mx-4"
            type="radio"
            value="(ご配送）ご自宅"
            checked={form.delivery === "(ご配送）ご自宅"}
            onClick={e => setForm({ ...form, delivery: "(ご配送）ご自宅" })}
          />
          <Label>（ご配送）ご自宅</Label>
        </Col>
      </Row>
      <Row className="d-flex align-items-center mt-2">
        <Col md={1}>
          <Label>預品</Label>
        </Col>
        <Col md={3}>
          {/* <DimensionInput
            name="deposit"
            onValueChange={(val, name) => handleChangeCurrency(val, name)}
            value={form.deposit}
          /> */}
          <Input
            type="text"
            id="deposit"
            name="deposit"
            placeholder="ゲスト名を入力"
            value={form.deposit}
            onChange={handleChangeInput}
          />
        </Col>

        <Col md={1}>
          <Label>修理代</Label>
        </Col>
        <Col md={3}>
          <DimensionInput
            name="repairFee"
            onValueChange={(val, name) => handleChangeCurrency(val, name)}
            value={form.repairFee}
          />
        </Col>
      </Row>
    </>
  )
}
